export default "__VITE_ASSET__D2ey6gx1__"